export default "__VITE_ASSET__68f641a0__"